import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #004c99;
  color: white;
  padding: 40px 20px;
  font-family: 'Arial', sans-serif;
  text-align: center;
`;

const LogoImage = styled.img`
  width: 160px; /* ajuste conforme tamanho ideal do seu logo */
  margin-bottom: 20px;
`;

const NavLinks = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`;

const LinkItem = styled.a`
  color: white;
  text-decoration: none;
  font-size: 16px;

  &:hover {
    text-decoration: underline;
  }
`;

const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0;
`;

const Icon = styled.img`
  width: 32px;
  height: 32px;
  cursor: pointer;
`;

const Copyright = styled.p`
  font-size: 14px;
  opacity: 0.7;
  margin-top: 30px;
`;

function Footer() {
  return (
    <FooterContainer>
      <LogoImage src="/images/logo-branco-nacao.png" alt="Logo Nação Saúde" />

      <NavLinks>
        <LinkItem href="#">Planos</LinkItem>
        <LinkItem href="https://nacaosaude.clubeparcerias.com.br/member/login">Meu Clube</LinkItem>
        <LinkItem href="#">Contato</LinkItem>
        <LinkItem href="https://nacaosaude.centraldeatendimento.me/rede">Rede Credenciada</LinkItem>
        <LinkItem href="#">Política de privacidade</LinkItem>
        <LinkItem href="#">Blog</LinkItem>
      </NavLinks>

      <SocialContainer>
        <a href="https://www.instagram.com/nacaosaude" target="_blank" rel="noopener noreferrer">
          <Icon src="/images/instagram.png" alt="Instagram" />
        </a>
        <a href="https://www.linkedin.com/company/nacaosaude/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
          <Icon src="/images/linkedin.png" alt="LinkedIn" />
        </a>
        <a href="https://www.youtube.com/@nacaosaudeapp" target="_blank" rel="noopener noreferrer">
          <Icon src="/images/youtube.png" alt="YouTube" />
        </a>
      </SocialContainer>

      <Copyright>
        Nação Saúde. Todos os Direitos Reservados.
      </Copyright>
    </FooterContainer>
  );
}

export default Footer;
